import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { StockPage } from './_dashboard.inventory.stock'

export const Route = createFileRoute('/_dashboard/inventory/stock/$item')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: StockItemPage,
})

function StockItemPage() {
  const { item } = Route.useParams()
  return <StockPage selectedId={item} />
}
